const safeParse = (n, def = 0, parse = parseFloat) =>
  isNaN(parse(n)) ? def : parse(n);

export default safeParse;
